import { InputNumber } from 'primereact/inputnumber';

const AIEduInputNumber = (props) => {
    const { title, titleStyle } = props;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
            }}
        >
            <label htmlFor={title} className={titleStyle}>
                {title}
            </label>
            <InputNumber {...props} />
        </div>
    );
};

export default AIEduInputNumber;
